import React, { memo, useState, Fragment } from 'react'
import withStyles from '@material-ui/core/styles/withStyles'
import classNames from 'classnames'
import ShowMoreIcon from 'root/src/client/public/ic-show-more'
import HorizontalLine from 'root/src/client/web/base/HorizontalLine'
import CommentWrapper from 'root/src/client/web/list/listComponents/CommentsList/CommentWrapper'
import ddAnonImage from 'root/src/client/public/dd-anon-image.jpg'
import equals from 'ramda/src/equals'
import { listStyle } from './styles'
import SignInPrompt from './SignInPrompt'
/* eslint-disable import/no-cycle */
import CommentConnected from './CommentConnected'
import Comment from './Comment'
/* eslint-enable import/no-cycle */

const CommentsList = memo(({
	list = [], getNextPage, moduleId, lastKey, classes, commentProps, isReplies, isAuthenticated,
}) => {
	const [openMessageId, setOpenMessage] = useState(null)

	return (
		<Fragment>
			<CommentWrapper>
				{equals(isAuthenticated, false) && (
					<div className={classNames('layout-row', classes.center, classes.root)}>
						<div className={classes.imageContainer}>
							<div
								className={classes.image}
								style={{
									backgroundImage: `url(${ddAnonImage})`,
								}}
							/>
						</div>
						<SignInPrompt signInPromptVisible text="to comment" className={classes.signInPrompt} />
					</div>
				)}
			</CommentWrapper>
			{
				list.length > 0
					? (
						<CommentWrapper>
							{list.map(props => (isReplies
								? (
									<Comment
										openMessageId={openMessageId}
										setOpenMessage={setOpenMessage}
										key={props.messageId}
										{...commentProps}
										commentData={props}
									/>
								)
								: (
									<CommentConnected
										openMessageId={openMessageId}
										setOpenMessage={setOpenMessage}
										recordId={props}
										key={props}
									/>
								)))}
							{!isReplies && (
								<div className={classes.bottomLineWrapper}>
									<HorizontalLine width={1112}>
										{lastKey && (
											<div className={classNames(
												'layout-row layout-align-center-center',
												classes.showMoreContainer,
											)}
											>
												<button
													type="button"
													className={classes.showMoreButton}
													onClick={() => getNextPage(moduleId, lastKey)}
												><ShowMoreIcon />
												</button>
											</div>
										)}
									</HorizontalLine>
								</div>
							)}
						</CommentWrapper>
					)
					: <div className={classes.noCommentsStab}>There are no comments yet.</div>
			}
		</Fragment>
	)
})

export default withStyles(listStyle, { name: 'MuiCommentsList' })(CommentsList)
